'use client';

import { advisorData } from 'content/advisorHelper';

export const useAdvisorHelper = (advisorId: string) => {
  return advisorData[advisorId];
};
